import React, { useEffect, useRef, useState } from "react";

import styled from "styled-components";
import { Menu, Button } from "antd";
import { NavLink } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import Hamburger from "hamburger-react";

import { getUserState } from "state/selector";
import { adminRoutes, userRoutes } from "routes";
import colors from "constants/palette";

export default function Sidebar(props) {
  const history = useHistory();
  const ref = useRef();

  const user = useSelector(getUserState);
  const userImage = "/images/user-avatar.svg";
  const routes = user.role === 2 ? userRoutes : adminRoutes;
  const [state, setState] = useState(false);

  useEffect(() => {
    // add when mounted
    document.addEventListener("mousedown", handleClick);
    // return function to be called when unmounted
    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      // If the menu is open and the clicked target is not within the menu,
      // then close the menu
      if (state && ref.current && !ref.current.contains(e.target)) {
        setState(false);
      }
    };

    document.addEventListener("mousedown", checkIfClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [state]);
  function handleHamClick() {
    setState((e) => !e);
  }
  function handleLinkClick() {
    setState(false);
  }

  function handleClick(e) {
    if (ref.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    if (state) {
      setState(false);
    }
  }
  return (
    <React.Fragment>
      <div ref={ref} style={{ display: "flex" }}>
        <MenuContainer state={state ? "true" : null}>
          <SidebarTop>
            <AvatarContainer>
              <img src={userImage} alt="avatar" />
              <AvatarTag>ادمین</AvatarTag>
            </AvatarContainer>
            <span>{user.name}</span>
          </SidebarTop>

          <Links>
            {routes.map((e, key) => (
              <NavItem
                exact
                to={e.link}
                active={e.link === history.location.pathname ? "true" : null}
                key={key}
                onClick={handleLinkClick}
              >
                <div>{e.icon}</div>
                <span className="text">{e.name}</span>
              </NavItem>
            ))}
          </Links>
        </MenuContainer>

        <HamButton type="primary" size={"large"} onClick={handleHamClick}>
          <Hamburger
            toggled={state}
            size={25}
            style={{ position: "absolute" }}
          />
        </HamButton>
      </div>
    </React.Fragment>
  );
}

const MenuContainer = styled(Menu)`
  display: flex;
  flex-direction: column;
  width: 264px;

  text-align: start;

  background: #232323d7;
  box-shadow: 0 4px 30px #00000019;
  backdrop-filter: blur(7.1px);
  -webkit-backdrop-filter: blur(7.1px);
  border: 1px solid #232323a7;
  border-radius: 0;

  &.ant-menu {
    border-left: none;
  }

  & hr {
    border-color: #aeaeae;
    width: 75%;
    margin: 12px auto;
  }
  position: relative;

  @media (max-width: 1080px) {
    position: fixed;
    /* animation: slideUp 0.3s ease-in-out
      ${({ state }) => (state ? "normal" : "reverse")} forwards; */
    z-index: 2;
    border-radius: 8px;
    overflow: hidden;
    bottom: -100vh;
    right: 5vw;
    transition: all 0.35s ease-in-out;
    ${({ state }) =>
      state
        ? `
    opacity: 1;
      bottom: calc(5vh + 75px);
    `
        : `
    opacity: 0;
      bottom: -100vh;
    `}
  }
  @keyframes slideUp {
    from {
      opacity: 0;
      bottom: -100vh;
    }
    to {
      opacity: 1;
      bottom: calc(5vh + 75px);
    }
  }
`;

const HamButton = styled(Button)`
  background: ${colors.primary} !important;
  border: none;
  position: fixed;
  bottom: 5vh;
  right: 5vw;
  align-content: center;
  justify-content: center;
  align-items: center;
  display: none;
  width: 54px;
  height: 54px;
  border-radius: 14px;
  z-index: 10;
  & .anticon {
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
  }
  & .hamburger-react {
    position: absolute !important;
  }

  @media (max-width: 1080px) {
    display: flex;
  }
`;

const AvatarContainer = styled.div`
  background: ${colors.white};
  width: 98px;
  height: 98px;
  & img {
    width: 68px;
    height: 68px;
    border-radius: 64px;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: 64px;
  border: 3px white solid;
  & img {
    /* border-radius: 64px; */
  }
`;
const AvatarTag = styled.span`
  background-color: ${colors.secondary};
  color: #3a4041;
  line-height: normal;
  padding: 3px 16px;
  border-radius: 9px;

  position: absolute;
  bottom: -12px;
  display: flex;
  z-index: 2;
`;
const SidebarTop = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 36px 28px;

  & > span {
    font-weight: normal;
    color: ${colors.sidebar.white};
    margin-top: 36px;
    display: block;
  }
`;

const Links = styled.div`
  margin-top: 36px;
`;

const NavItem = styled(NavLink)`
  line-height: 32px;
  transition: all 0.35s ease-in-out;
  padding: 9px 14px;
  width: 80%;
  margin: 9px auto;
  color: ${({ active }) =>
    active ? colors.sidebar.dark : colors.sidebar.white} !important;
  background-color: ${({ active }) => (active ? "#ffffff" : "")};
  border-radius: 10px;
  position: relative;
  display: flex;
  &:hover {
    background-color: ${({ active }) => (active ? "" : "#ffffff1a")};
  }
  & div {
    display: block;
    overflow: hidden;
    width: 36px;
    height: 36px;

    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    transition: all 0.3s ease-in-out;
    color: #989898;
    color: ${({ active }) => active && colors.primary};
    /* box-shadow: 0 0 9px 1px #ffffff3d; */
  }

  & .text {
    margin-right: 32px;
  }
  /* background: ${({ active }) =>
    active &&
    ` linear-gradient(270deg, ${colors.white} 65%, ${
      colors.secondary + "40"
    } 100%)`}; */
  &:hover {
    /* background: ${({ active }) => !active && "#ffffffa0"}; */
  }
`;
